<template>
  <div class="renderPage ing-container" :class="{ 'theme--dark': $vuetify.theme.dark }">

    <!-- TOOLBAR CABECERA -->
    <v-toolbar flat height="56" :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="ing-toolbar px-2">
      <v-icon class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-package-variant-closed-plus</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase ing-toolbar-title" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-4'">
        Entradas de Inventario
      </v-toolbar-title>
      <v-spacer />
      <v-btn depressed color="primary" class="ing-btn font-weight-bold" @click="incluir()">
        <v-icon left small>mdi-plus</v-icon> Nuevo Ingreso
      </v-btn>
    </v-toolbar>

    <!-- TABLA -->
    <v-card flat class="ing-table-card mx-0" :color="$vuetify.theme.dark ? '#0f172a' : 'white'">
      <v-toolbar flat height="auto" :color="$vuetify.theme.dark ? '#0f172a' : 'white'" class="px-3 py-2">
        <v-row dense align="center">
          <v-col cols="12" sm="4">
            <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="dates" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="datesFormat"
                  label="Rango de fechas"
                  prepend-inner-icon="mdi-calendar"
                  readonly outlined dense hide-details
                  class="ing-search"
                  v-bind="attrs" v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" range @click="setDatesFormat()">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateModal = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(dates); setDatesFormat(); getData();">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="1">
            <v-btn icon :color="$vuetify.theme.dark ? 'blue-grey lighten-2' : 'grey darken-1'" @click="getData()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Filtrar por código o descripción..."
              single-line hide-details outlined dense
              class="ing-search"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="ing-table"
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [25, 50, -1] }"
        @click:row="editItem"
        style="cursor:pointer"
      >
        <template v-slot:[`item.codigo`]="{ item }">
          <span class="ing-code-badge">#{{ item.codigo }}</span>
        </template>

        <template v-slot:[`item.fechaString`]="{ item }">
          <div class="d-flex align-center">
            <v-icon small class="mr-1" :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">mdi-clock-outline</v-icon>
            <span class="body-2">{{ item.fechaString }}</span>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn color="blue-grey darken-2" depressed dark style="min-width:36px;height:36px;padding:0;border-radius:4px" @click.stop="editItem(item)">
            <v-icon size="18">mdi-eye-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <div class="pa-8 text-center">
            <v-icon size="48" :color="$vuetify.theme.dark ? 'blue-grey darken-1' : 'grey lighten-1'" class="mb-3">mdi-package-variant</v-icon>
            <p :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">No hay ingresos registrados en este rango de fechas.</p>
            <v-btn color="primary" depressed small @click="getData()">Cargar de nuevo</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- DRAWER FORMULARIO -->
    <v-navigation-drawer v-model="drawerForm" fixed right temporary width="800" class="ing-drawer" persistent>
      <div class="d-flex flex-column fill-height">

        <!-- HEADER DRAWER -->
        <div class="ing-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'ing-drawer-header--dark' : ''">
          <v-icon color="white" class="mr-3">{{ editedIndex > -1 ? 'mdi-package-variant-closed' : 'mdi-package-variant-closed-plus' }}</v-icon>
          <div>
            <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">
              {{ editedIndex > -1 ? 'Detalle de Ingreso' : 'Nuevo Ingreso' }}
            </div>
            <div class="caption white--text" style="opacity:0.7">Movimiento #{{ editedItem.codigo }}</div>
          </div>
          <v-spacer />
          <v-btn icon dark small @click="cerrar()"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <!-- CUERPO -->
        <div class="flex-grow-1 overflow-y-auto pa-5">
          <v-form ref="form" v-model="valid">
            <v-row dense>
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="editedItem.descripcion"
                  label="Descripción o Comentario"
                  outlined dense
                  :rules="nameRules"
                  :readonly="editedIndex > -1"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="fecha"
                  label="Fecha"
                  outlined dense readonly
                  prepend-inner-icon="mdi-calendar"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- TABLA ARTÍCULOS -->
            <div class="ing-section-label mb-2 mt-2">
              <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-format-list-bulleted</v-icon>
              <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Artículos Incluidos</span>
              <v-spacer />
              <v-btn v-if="editedIndex === -1" color="primary" depressed small class="ing-btn font-weight-bold" @click="mostrarBuscarArticulos">
                <v-icon left small>mdi-plus</v-icon> Agregar Artículo
              </v-btn>
            </div>

            <v-card flat class="ing-section-card overflow-hidden">
              <v-data-table
                hide-default-footer
                :headers="headersDetalle"
                :items="lineasDetalle"
                class="ing-table"
                dense
                no-data-text="No hay artículos en este movimiento."
              >
                <template v-slot:[`item.articulo`]="{ item }">
                  <span class="font-weight-bold">{{ item.articulo }}</span>
                </template>

                <template v-slot:[`item.cantidad`]="{ item }">
                  <span class="success--text font-weight-bold">x {{ item.cantidad }}</span>
                </template>

                <template v-slot:[`item.costo`]="{ item }">
                  <span class="body-2">{{ item.costo | currency }}</span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <div class="d-flex justify-end" v-if="editedIndex === -1">
                    <v-btn color="blue-grey darken-2" depressed dark class="mr-1" style="min-width:32px;height:32px;padding:0;border-radius:4px" @click="detalleEditItem(item)">
                      <v-icon size="16">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="error" depressed dark style="min-width:32px;height:32px;padding:0;border-radius:4px" @click="deleteItem(item)">
                      <v-icon size="16">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </v-form>
        </div>

        <!-- FOOTER ACCIONES -->
        <div class="ing-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'ing-drawer-footer--dark' : ''">
          <v-spacer />
          <v-btn text class="mr-3 font-weight-bold ing-btn" @click="cerrar()">{{ editedIndex > -1 ? 'Cerrar' : 'Cancelar' }}</v-btn>
          <v-btn
            v-if="editedIndex === -1"
            color="primary" depressed
            class="px-8 font-weight-bold ing-btn"
            :loading="loading"
            :disabled="lineasDetalle.length === 0"
            @click="save()"
          >
            GUARDAR INGRESO
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- DIALOGO: EDITAR ARTÍCULO DEL DETALLE -->
    <v-dialog v-model="dialogArticulos" max-width="500px" persistent>
      <v-card flat class="ing-dialog-card">
        <div class="ing-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'ing-drawer-header--dark' : ''">
          <v-icon color="white" small class="mr-2">mdi-pencil</v-icon>
          <div>
            <div class="white--text font-weight-black text-uppercase" style="font-size:0.85rem;letter-spacing:1px">Datos del Artículo</div>
            <div class="caption white--text" style="opacity:0.7">{{ detalleEditedItem.descripcion }}</div>
          </div>
          <v-spacer />
          <v-btn icon dark x-small @click="close()"><v-icon small>mdi-close</v-icon></v-btn>
        </div>
        <div class="pa-5">
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field v-model="detalleEditedItem.cantidad" type="number" label="Cantidad" outlined dense autofocus></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="detalleEditedItem.costo" type="number" label="Costo Unitario" outlined dense prefix="₡"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="detalleEditedItem.precio" type="number" label="Precio Venta" outlined dense prefix="₡"></v-text-field>
            </v-col>
          </v-row>
          <div class="d-flex justify-end mt-2">
            <v-btn text class="mr-2 font-weight-bold" @click="close()">Cancelar</v-btn>
            <v-btn color="primary" depressed class="ing-btn font-weight-bold px-6" @click="saveDetalleArticulo">Agregar</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- DIALOGO BUSCADOR DE ARTÍCULOS -->
    <v-dialog transition="dialog-bottom-transition" v-model="dialogBuscarArticulos" width="1000">
      <div v-if="showNewDataArti">
        <BuscarArticulos v-bind:allwedOnly="true" :quickAdd="true" @quick-add="handleQuickAdd" @clicked="selectedArticulos" @closed="closed" />
      </div>
    </v-dialog>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";
import BuscarArticulos from "./BuscarArticulos.vue";

export default {
    components: {
        Snackbar,
        BuscarArticulos,
    },
    filters: {
        currency(val) {
            return new Intl.NumberFormat('es-CR', { style: 'currency', currency: 'CRC' }).format(val);
        }
    },
    data() {
        return {
            drawerForm: false,
            loading: false,
            dialogArticulos: false,
            dialogBuscarArticulos: false,
            valid: false,
            search: "",
            snackText: "",
            snackValue: false,
            dateModal: false,
            dates: [],
            datesFormat: [],
            fecha: "",
            headers: [
                { text: "Cód. Movimiento", value: "codigo", sortable: true },
                { text: "Descripción", value: "descripcion", sortable: true },
                { text: "Fecha", value: "fechaString", sortable: true },
                { text: "Ver", value: "actions", width: 50, sortable: false, align: 'right' },
            ],
            headersDetalle: [
                { text: "Cód.", value: "articulo" },
                { text: "Descripción", value: "descripcion" },
                { text: "Cant.", value: "cantidad", align: 'center' },
                { text: "Costo", value: "costo", align: 'right' },
                { text: "Acciones", value: "actions", width: 80, sortable: false, align: 'right' },
            ],
            items: [],
            lineasDetalle: [],
            editedIndex: -1,
            modelMovimiento: {
                movimiento: [],
                detalles: [],
            },
            editedItem: {
                cia: "",
                codigo: "",
                descripcion: "",
                fecha: new Date().toISOString().slice(0, 10),
                tipo: 1,
            },
            defaultItem: {
                cia: "",
                codigo: "",
                descripcion: "",
                fecha: new Date().toISOString().slice(0, 10),
                tipo: 1,
            },
            detalleEditedIndex: -1,
            detalleEditedItem: {
                articulo: "",
                cabys: "",
                descripcion: "",
                cantidad: 1,
                costo: 0,
                precio: 0,
            },
            detalleDefaultItem: {
                articulo: "",
                cabys: "",
                descripcion: "",
                cantidad: 1,
                costo: 0,
                precio: 0,
            },
            showNewDataArti: false,
            nameRules: [(v) => !!v || "Este campo es requerido"],
            dateRules: [(v) => !!v || "Debe seleccionar un rango"],
        };
    },

    computed: {
        ...mapGetters(["user", "strCia"]),
    },

    created() {
        this.setDates();
        this.getData();
    },

    methods: {
        getData() {
            if (this.dates.length < 2) return;
            axios.get(`api/Articulos/getArticulosMovimientos?cia=${this.strCia}&tipo=1&fechaInicio=${this.dates[0]}&fechaFin=${this.dates[1]}`)
                .then(res => { this.items = res.data; })
                .catch(err => console.error(err));
        },

        setDates() {
            const date = new Date();
            const dateInicio = new Date(date.getFullYear(), date.getMonth(), 1);
            this.dates = [
                dateInicio.toISOString().substr(0, 10),
                date.toISOString().substr(0, 10)
            ];
            this.setDatesFormat();
        },

        setDatesFormat() {
            if (this.dates.length === 2) {
                const d1 = this.dates[0].split('-');
                const d2 = this.dates[1].split('-');
                this.datesFormat = `${d1[2]}/${d1[1]}/${d1[0]} - ${d2[2]}/${d2[1]}/${d2[0]}`;
            }
        },

        mostrarBuscarArticulos() {
            this.showNewDataArti = true;
            this.dialogBuscarArticulos = true;
        },

        editItem(item) {
            this.editedIndex = this.items.indexOf(item);
            this.getModeloMovimiento(item.codigo);
            this.drawerForm = true;
        },

        getModeloMovimiento(codigo) {
            this.loading = true;
            axios.get(`api/Articulos/getModeloArticulosMovimientos?cia=${this.strCia}&codigo=${codigo}&tipo=1`)
                .then(res => {
                    this.editedItem = res.data.movimiento;
                    this.lineasDetalle = res.data.detalles;
                    this.fecha = this.editedItem.fechaString;
                })
                .finally(() => { this.loading = false; });
        },

        selectedArticulos(value) {
            this.showNewDataArti = false;
            this.dialogBuscarArticulos = false;

            this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
            this.detalleEditedItem.articulo = value.codigo;
            this.detalleEditedItem.descripcion = value.nombre;
            this.detalleEditedItem.cabys = value.cabys;
            this.detalleEditedItem.costo = value.costo || 0;
            this.detalleEditedItem.precio = value.monto || 0;

            this.detalleEditedIndex = -1;
            this.dialogArticulos = true;
        },

        handleQuickAdd({ item, qty, cost, price }) {
            this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
            this.detalleEditedItem.articulo = item.codigo;
            this.detalleEditedItem.descripcion = item.nombre;
            this.detalleEditedItem.cabys = item.cabys;
            this.detalleEditedItem.cantidad = qty;
            this.detalleEditedItem.costo = cost;
            this.detalleEditedItem.precio = price;

            this.lineasDetalle.push(Object.assign({}, this.detalleEditedItem));
            this.snackText = `Agregado: ${item.nombre}`;
            this.snackValue = true;
            this.drawerForm = true;
        },

        detalleEditItem(item) {
            this.detalleEditedIndex = this.lineasDetalle.indexOf(item);
            this.detalleEditedItem = Object.assign({}, item);
            this.dialogArticulos = true;
        },

        deleteItem(item) {
            if (confirm("¿Descartar este artículo del movimiento?")) {
                const index = this.lineasDetalle.indexOf(item);
                this.lineasDetalle.splice(index, 1);
            }
        },

        saveDetalleArticulo() {
            if (this.detalleEditedIndex > -1) {
                Object.assign(this.lineasDetalle[this.detalleEditedIndex], this.detalleEditedItem);
            } else {
                this.lineasDetalle.push(Object.assign({}, this.detalleEditedItem));
            }
            this.close();
            this.$nextTick(() => { this.drawerForm = true; });
        },

        close() {
            this.dialogArticulos = false;
            this.$nextTick(() => {
                this.detalleEditedItem = Object.assign({}, this.detalleDefaultItem);
                this.detalleEditedIndex = -1;
            });
        },

        closed() {
            this.showNewDataArti = false;
            this.dialogBuscarArticulos = false;
            this.$nextTick(() => {
                setTimeout(() => { this.drawerForm = true; }, 50);
            });
        },

        save() {
            if (!this.$refs.form.validate() || this.lineasDetalle.length === 0) return;
            this.loading = true;
            this.editedItem.cia = this.strCia;
            const model = {
                movimiento: this.editedItem,
                detalles: this.lineasDetalle
            };

            axios.post("api/Articulos/insertArticulosMovimientos", model)
                .then(() => {
                    this.snackText = "Ingreso registrado satisfactoriamente";
                    this.snackValue = true;
                    this.getData();
                    this.cerrar();
                })
                .finally(() => { this.loading = false; });
        },

        incluir() {
            this.editedIndex = -1;
            this.editedItem = Object.assign({}, this.defaultItem);
            this.lineasDetalle = [];

            axios.get("api/Facturacion/getFechaActualString").then(res => { this.fecha = res.data; });
            axios.get("api/Articulos/getCodigoArticulosMovimientos?cia=" + this.strCia).then(res => {
                this.editedItem.codigo = res.data;
                this.drawerForm = true;
            });
        },

        cerrar() {
            this.drawerForm = false;
            this.$nextTick(() => {
                this.editedIndex = -1;
                this.editedItem = Object.assign({}, this.defaultItem);
                this.lineasDetalle = [];
            });
        },
    },
};
</script>

<style scoped>
/* ===== CONTAINER ===== */
.ing-container {
  background-color: #f1f5f9;
  min-height: 100vh;
}
.theme--dark.ing-container {
  background-color: #0f172a;
}

/* ===== TOOLBAR ===== */
.ing-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.theme--dark .ing-toolbar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.07) !important;
}
.ing-toolbar-title {
  font-size: 0.95rem !important;
  letter-spacing: 1.5px;
}

/* ===== BUTTONS ===== */
.ing-btn {
  border-radius: 4px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 0.75rem !important;
}

/* ===== TABLE ===== */
.ing-table-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.ing-table { background: transparent !important; }
.ing-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.ing-table >>> tbody tr { cursor: pointer; }
.ing-table >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.05) !important;
}
.theme--dark .ing-table >>> tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* ===== CODE BADGE ===== */
.ing-code-badge {
  font-family: monospace;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 2px 6px;
  background: rgba(55, 71, 79, 0.08);
  border-radius: 3px;
  color: #37474f;
}
.theme--dark .ing-code-badge {
  background: rgba(255, 255, 255, 0.1);
  color: #b0bec5;
}

/* ===== SEARCH ===== */
.ing-search >>> .v-input__slot {
  border-radius: 4px !important;
}

/* ===== DRAWER ===== */
.ing-drawer >>> .v-navigation-drawer__content {
  background-color: #ffffff !important;
}
.theme--dark .ing-drawer >>> .v-navigation-drawer__content {
  background-color: #0f172a !important;
}

/* ===== DRAWER HEADER ===== */
.ing-drawer-header {
  background-color: #37474f;
  flex-shrink: 0;
}
.ing-drawer-header--dark {
  background-color: #263238 !important;
}

/* ===== DRAWER FOOTER ===== */
.ing-drawer-footer {
  background-color: #f8fafc;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.ing-drawer-footer--dark {
  background-color: #1e293b !important;
  border-top: 1px solid rgba(255, 255, 255, 0.07) !important;
}

/* ===== SECTION LABEL ===== */
.ing-section-label {
  display: flex;
  align-items: center;
}

/* ===== SECTION CARD ===== */
.ing-section-card {
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 4px !important;
  background-color: #ffffff !important;
}
.theme--dark .ing-section-card {
  border-color: rgba(255, 255, 255, 0.07) !important;
  background-color: #1e293b !important;
}

/* ===== DIALOG CARD ===== */
.ing-dialog-card {
  border-radius: 4px !important;
  overflow: hidden;
}
</style>
